import React from 'react';
import { config } from '../config';

const DebugInfo: React.FC = () => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: 'rgba(0,0,0,0.8)',
      color: 'white',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 9999,
      maxWidth: '300px',
      display: 'none'
    }}>
      <h4>Debug Info</h4>
      <div>NODE_ENV: {process.env.NODE_ENV}</div>
      <div>REACT_APP_API_URL: {process.env.REACT_APP_API_URL || 'not set'}</div>
      <div>REACT_APP_WS_URL: {process.env.REACT_APP_WS_URL || 'not set'}</div>
      <div>API_BASE_URL: {config.API_BASE_URL}</div>
      <div>WS_BASE_URL: {config.WS_BASE_URL}</div>
      <div>isProduction: {config.isProduction.toString()}</div>
    </div>
  );
};

export default DebugInfo; 